import React from 'react'

import logo from '../../assets/img/semalcool.png'

const BebidasSemAlcoolImageImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Bebidas' style={{ width: '100%' }} />
  </div>
)

export default BebidasSemAlcoolImageImage